import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const usePaginationState = (
  storageKey,
  defaultState,
  preservePaths = []
) => {
  const location = useLocation();

  // Initialize from storage or default
  const [payload, setPayload] = useState(() => {
    try {
      const savedState = sessionStorage.getItem(storageKey);
      return savedState ? JSON.parse(savedState) : defaultState;
    } catch (error) {
      console.error("Error loading pagination state:", error);
      return defaultState;
    }
  });

  // Save state when it changes
  useEffect(() => {
    sessionStorage.setItem(storageKey, JSON.stringify(payload));
  }, [payload, storageKey]);

  // We need to handle cleanup in the component, not in the hook
  // This function can be called explicitly by the component
  const clearStorageData = () => {
    sessionStorage.removeItem(storageKey);
  };

  return [payload, setPayload, clearStorageData];
};
